import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: ['sans-serif'].join(','),
        h1: {
            fontSize: '36px',
            fontWeight: '700',
            color: '#ff0000',
        },
        h2: {
            fontSize: '30px',
            fontWeight: '700',
            color: '#1c5787',
        },
        h3: {
            fontSize: '24px',
            fontWeight: '700',
            color: '#1c5787',
        },
        h4: {
            fontSize: '20px',
            fontWeight: '700',
            color: '#1c5787',
        },
        h5: {
            fontSize: '16px',
            fontWeight: '700',
            color: '#1c5787',
        },
        h6: {
            fontSize: '14px',
            fontWeight: '700',
            color: '#1c5787',
            letterSpacing: '0.5px',
        },
        body1: {
            fontSize: '14px',
            color: '#555555',
        },
        body2: {
            fontSize: '12px',
            color: '#555555',
        },
    },
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: 'black',
                    backgroundColor: 'white',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    paddingTop: '18px',
                    paddingBottom: '18px',
                    color: '#ff0000',
                    fontSize: '13px',
                    whiteSpace: 'nowrap',
                },
                body: {
                    fontSize: '13px',
                },
            },
        },
    },
    palette: {
        primary: {
            main: '#000000', // Black from logo
            light: '#f65c5b',
            dark: '#85000b',
        },
        secondary: {
            main: '#eb3037', // Red from logo
            light: '#f65c5b',
            dark: '#85000b',
        },
        background: {
            default: '#ffffff', // White background
        },
        text: {
            primary: '#000000',
            secondary: '#ff0000',
            disabled: 'rgba(0,0,0,0.38)',
        },
    },
});

export default theme;
